import { Mail, Clock, MessageCircle, MapPin } from "lucide-react";
import { SectionHead, Reveal } from "../Reveal";
import { ContactForm } from "../ContactForm";
import { SITE, whatsappLink, ADDRESSES } from "../../data/site";

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="relative py-20 sm:py-28 bg-[#04070F] overflow-hidden">
    <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-blue-700/15 blur-[160px]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="Contact Us"
        title={
          <>
            Your Career Pivot Starts With <span className="text-gradient-orange">One Message</span>
          </>
        }
        sub="Fill the form or ping us on WhatsApp — a real counsellor (not a bot) replies within 2–4 hours."
      />

      <div className="grid lg:grid-cols-2 gap-10 items-start">
        <Reveal className="space-y-6">
          <div className="rounded-2xl border border-sky-500/20 bg-[#0B1226] p-7 space-y-5">
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 group" data-testid="contact-email-link">
              <span className="w-12 h-12 rounded-xl bg-blue-600/20 border border-sky-500/30 flex items-center justify-center group-hover:border-orange-500/50 transition-colors duration-300">
                <Mail className="w-5 h-5 text-sky-400" />
              </span>
              <span>
                <span className="block text-xs text-slate-500 uppercase tracking-wider font-mono2">Email us</span>
                <span className="block text-sm font-semibold text-white group-hover:text-orange-400 transition-colors duration-200">{SITE.email}</span>
              </span>
            </a>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group" data-testid="contact-whatsapp-link">
              <span className="w-12 h-12 rounded-xl bg-[#25D366]/15 border border-[#25D366]/40 flex items-center justify-center group-hover:bg-[#25D366]/25 transition-colors duration-300">
                <MessageCircle className="w-5 h-5 text-[#25D366]" />
              </span>
              <span>
                <span className="block text-xs text-slate-500 uppercase tracking-wider font-mono2">WhatsApp (fastest)</span>
                <span className="block text-sm font-semibold text-white group-hover:text-[#25D366] transition-colors duration-200">+91 76961 18858</span>
              </span>
            </a>
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 rounded-xl bg-orange-500/15 border border-orange-500/40 flex items-center justify-center">
                <Clock className="w-5 h-5 text-orange-400" />
              </span>
              <span>
                <span className="block text-xs text-slate-500 uppercase tracking-wider font-mono2">Counsellor hours</span>
                <span className="block text-sm font-semibold text-white">8 AM – 11 PM IST, 7 days a week</span>
              </span>
            </div>
            <div className="flex items-start gap-4" data-testid="contact-address">
              <span className="w-12 h-12 shrink-0 rounded-xl bg-blue-600/20 border border-sky-500/30 flex items-center justify-center">
                <MapPin className="w-5 h-5 text-sky-400" />
              </span>
              <span>
                <span className="block text-xs text-slate-500 uppercase tracking-wider font-mono2">Our Offices</span>
                <span className="block text-xs text-slate-300 mt-1.5 leading-relaxed">
                  <span className="text-white font-semibold">India:</span> {ADDRESSES.india}
                </span>
                <span className="block text-xs text-slate-300 mt-1.5 leading-relaxed">
                  <span className="text-white font-semibold">USA:</span> {ADDRESSES.usa}
                </span>
              </span>
            </div>
          </div>
          <div className="rounded-2xl border border-orange-500/30 bg-gradient-to-br from-orange-500/10 to-transparent p-7">
            <p className="font-display text-lg font-bold text-white">Not sure which course fits you?</p>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Take the free demo. Tell us your background and target role — your trainer will map a personalised
              roadmap in the first session itself, no commitment needed.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="glass-card rounded-2xl border border-sky-500/25 p-7 sm:p-9 shadow-[0_0_60px_rgba(29,78,216,0.12)]">
            <h3 className="font-display text-xl font-bold text-white mb-6">Send an Enquiry</h3>
            <ContactForm idPrefix="contact" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
